<template>
	<!-- 팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
	<div id="popupRegalFr" class="popup-wrapp" hidden>
		<div class="popup popup-type1" role="dialog" aria-labelledby="popupRegalFrTitle">
			<div class="blind-area popup-focus dv-ios-only" role="text" :aria-label="$t('gwa.alt.common.wa_label_60')"><!-- IOS접근성 영역자체에 초점처리 --></div>
			<div class="popup-container">
				<div class="popup-header">
					<h3 class="tit-h3" id="popupRegalFrTitle">{{ $t('sdp.menu.device.terms.pop') }}</h3>
				</div>
				<div class="popup-header">
				</div>
				<div class="popup-body popup-scroll">
					<div class="para-wrap">
						<p class="para">{{ $t('sdp.menu.device.terms.pop.message.001') }}</p>
						<p class="para pd10">{{ $t('sdp.menu.device.terms.pop.message.002') }}</p>
						<p class="para pd10">{{ $t('sdp.menu.device.terms.pop.message.003') }}</p>
						<p class="para pd10">{{ $t('sdp.menu.device.terms.pop.message.004') }}</p>
						<p class="para pd10">{{ $t('sdp.menu.device.terms.pop.message.005') }}</p>
						<p class="para pd10">{{ $t('sdp.menu.device.terms.pop.message.006') }}</p>
					</div>
				</div>
				<div class="popup-footer">
					<div class="btn-wrap">
						<button type="button" @click="closeDimmer()" class="btn btn-type2 popup-close btn-secondary" aria-controls="popupRegalFr" :title="$t('gwa.alt.inquiry.wa_title_1')"><span>{{ $t('sdp.message.layerpopup.close') }}</span></button>
					</div>
				</div>
				<button type="button" @click="closeDimmer()" class="btn-ico btn-popup-close popup-close" aria-controls="popupRegalFr" :title="$t('gwa.alt.inquiry.wa_title_1')"><span><i class="ico ico-close2">{{ $t('gwa.alt.common.wa_label_19') }}</i></span></button>
			</div>
		</div>
	</div>
	<!-- //팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
</template>

<script>
    import qs from "qs";

    export default {
        name: "TermsPop",
        data() {
            return {
            	cntryCode: _domainCntryCode
            }
        },
        created() {
        },
        watch: {
        },
        computed: {
        },
        methods: {
            closeDimmer() {
            	ui.popupp.close("popupRegalFr");
            }
        },
        mounted() {
        	document.body.addEventListener('keyup', e => {
       	        if (e.keyCode == 27) {
       	        	ui.popupp.close("popupRegalFr");
       	        }
       	    });
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
